/**
 * Export all public constructs under this namespace.
 */

export * from "./isAndroid";
export * from "./isIOS";
